import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FieldComponent } from './field.component';
import { FieldSuffixItemDirective } from './suffix-item/suffix-item.component';

@NgModule({
  imports: [CommonModule],
  declarations: [FieldComponent, FieldSuffixItemDirective],
  exports: [FieldComponent, FieldSuffixItemDirective],
})
export class FieldModule {}
